import React, { Component } from "react";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import ReportSODetail from "./reportSODetail";
import FlexView from "react-flexview";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import { fetchDataAsync } from "../../../../Services/Utils";
import Api from "../../../../Services/Api";
import { HttpStatus } from "../../../common/Constants";
import {
  buildPayloadByReportType,
  downloadPdf,
  mapNonQrByType,
  mapQr,
  mapSummaryNonQr,
  mapSummaryQr,
} from "../service";
import { printPDF } from "./downloadUtils";

const DEFAULT_PRINT_TYPES = [
  { value: "REPORT_SO", label: "Cetakan Report Stock Opname" },
  { value: "KELEBIHAN_SO", label: "Cetakan Kelebihan Stock Opname" },
  { value: "KEKURANGAN_SO", label: "Cetakan Kekurangan Stock Opname" },
  { value: "SUMMARY_SO", label: "Cetakan Summary Stock Opname" },
];

class ReportSO extends Component {
  constructor(props) {
    super(props);
    this.state = {
      printVisible: false,
      jenisCetakan: [],
      cetakan: [],
    };
  }

  componentDidMount() {
    const type = this.props.controls.stockOpnameType?.value;

    const prefixMap = {
      UNIT: "UNIT",
      PART: "PART",
      KSU: "KSU",
      GIFT: "GIFT",
      OTHER_ITEM: "OTHER_ITEM",
    };

    const prefix = prefixMap[type?.value] || "KSU";

    const enhancedJenisCetakan = DEFAULT_PRINT_TYPES.map((item) => ({
      ...item,
      value: `${prefix}_${item.value}`,
    }));

    this.setState((prev) => ({
      ...prev,
      jenisCetakan: enhancedJenisCetakan,
      cetakan: enhancedJenisCetakan[0],
    }));
  }

  handlePrintVisible = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      printVisible: !prevValue.printVisible,
    }));
  };

  handleUpdatePrintCount = async () => {
    let stockOpnameNo = this.props.selectedData.stockOpnameNo
    let cetakan = this.state.cetakan.value;

    let type = cetakan?.includes("REPORT_SO")
      ? "ASSET_REPORT_SO"
      : cetakan?.includes("KELEBIHAN_SO")
      ? "ASSET_KELEBIHAN_SO"
      : cetakan?.includes("KEKURANGAN_SO")
      ? "ASSET_KELEBIHAN_SO"
      : "ASSET_SUMMARY_SO";

    try {
      const reqBody = {
        refNumber: stockOpnameNo,
        type: type,
      };
      const res = await Api.create("NAGAMAS_REPORT_DTO").updatePrintCount(reqBody)
      if (res.ok && res.data.data) {
        this.handlePrintCetakan(res.data.data)
      }
    } catch (e) {
      console.log(e);
    }
  };

  handlePrintCetakan = async (countCetakan) => {
    this.props.handleLoading();
    const { controls, auth, state } = this.props;

    let resUser = await Api.create("NAGAMAS_MASTER_DATA").getUserProfile({
      idUser: auth.user.idUser,
    });

    let printBy = resUser?.data?.data?.name ?? "-";
    const soType = controls.stockOpnameType?.value?.value;
    const selectedType = this.state.cetakan?.value;
    const pickedReport = selectedType.replace(`${soType}_`, "");

    const listNonQr = state.reportSO.listDataTanpaQR || [];
    const listQr = state.reportSO.listDataQR || [];

    //adjustment cetakan
    const listNamaUser = (state?.reportSO?.listDataQR || [])
      .map(item => item?.userId)
      .filter(Boolean); 

    const resolveName = state?.dataKekurangan?.userResolveStockOpname?.name;
    if (resolveName) listNamaUser.push(resolveName);

    if (soType === "UNIT" || soType === "KSU") {
      const response = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_REPORT").printStockOpname,
        menuName: "Report Stock Opname",
        setError: this.props.setError,
        args: {
          stockOpnameNo: controls.noStockOpname?.value,
          stockOpnameReportType: selectedType,
          listNamaUser
        },
      });

      if (response.ok) printPDF(response.data);

      this.props.handleLoading();
      return;
    }

    const basePayload = {
      noStockOpname: controls.noStockOpname?.value,
      stockOpnameDate: controls.stockOpnameDate?.value,
      stockOpnameType: soType == 'OTHER_ITEM' ? 'BARANG LAIN' : soType == 'GIFT' ? 'HADIAH' : soType,
      cabang: controls.kodeCabang?.value?.label,
      locator: controls.kodeLocation?.value?.label,
      printBy,
      printOf: countCetakan,
    };

    const { apiFn, payload } = buildPayloadByReportType({
      pickedReport,
      soType,
      basePayload,
      listNonQr,
      listQr,
      controls,
      state,
    });
    console.log(payload);

    const response = await fetchDataAsync({
      asyncFn: apiFn,
      menuName: "Report Stock Opname",
      setError: this.props.setError,
      args: payload,
    });

    if (response.ok) printPDF(response.data);
    this.setState({ loading: false, alertVisible: false, cetak: true });

    this.props.handleLoading();
  };

  render() {
    return (
      <>
        <Tabs>
          <TabList>
            <Tab id="dengan_qr">Dengan QR</Tab>
            <Tab id="tanpa_qr">Tanpa QR</Tab>
          </TabList>
          <TabPanel>
            <ReportSODetail
              tab="with_qr"
              dataTable={this.props.state.reportSO.listDataQR}
              {...this.props}
            />
          </TabPanel>
          <TabPanel>
            <ReportSODetail
              tab="without_qr"
              dataTable={this.props.state.reportSO.listDataTanpaQR}
              {...this.props}
            />
          </TabPanel>
        </Tabs>
        <FlexView style={{ justifyContent: "end", marginTop: "10px" }}>
          <SimpleButton onClick={this.handlePrintVisible}>Print</SimpleButton>
        </FlexView>
        {this.state.printVisible && (
          <SimpleModal
            title="Cetakan"
            styles={{ width: "50%" }}
            visible={this.state.printVisible}
            onClickClose={this.handlePrintVisible}
            content={
              <ModalContainer>
                <FlexView>
                  <SimpleDDL
                    box="search"
                    name="cetakan"
                    label="Jenis Cetakan"
                    options={this.state.jenisCetakan}
                    value={this.state.cetakan}
                    onChange={(value, { name }) =>
                      this.setState((prevValue) => ({
                        ...prevValue,
                        cetakan: value,
                      }))
                    }
                    containerclassname="width width-500px"
                  />
                </FlexView>
                <FlexView style={{ justifyContent: "end" }}>
                  <SimpleButton onClick={this.handleUpdatePrintCount}>
                    Cetak
                  </SimpleButton>
                </FlexView>
              </ModalContainer>
            }
          />
        )}
      </>
    );
  }
}

export default ReportSO;
